import { defineStore } from 'pinia'
import { defHttp } from '@utils/http'

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    list: [],
    total: 0,
    unreadCount:0,
    unreadCountByType: {},
    unreadTypeList: [],
    loading: false,
    personalConfig:{},//用户通知配置
  }),
  getters: {},
  actions: {
    async fetchList() {
      this.loading = true
      try {
        const res = await defHttp.get(`/api/notify/list`, {})
        const data = res?.data?.data || {}
        const list = Array.isArray(data.list) ? data.list : []
        const typeList = Array.isArray(data.unreadTypeList)
          ? data.unreadTypeList
          : []
        const responseCountByType =
          data.unreadCountByType && typeof data.unreadCountByType === 'object'
            ? data.unreadCountByType
            : {}
        const countByType = {}

        Object.entries(responseCountByType).forEach(([typeCode, count]) => {
          countByType[String(typeCode).toLowerCase()] = Number(count) || 0
        })
        typeList.forEach((item) => {
          const typeCode = String(item?.typeCode || '').toLowerCase()
          if (typeCode && countByType[typeCode] == null) {
            countByType[typeCode] = Number(item?.unreadCount) || 0
          }
        })

        this.list = list
        this.unreadCountByType = countByType
        this.unreadTypeList = typeList

        const totalUnread = Number(data.totalUnread)
        this.unreadCount = Number.isFinite(totalUnread) ? totalUnread : 0
        this.total = this.unreadCount
      } finally {
        this.loading = false
      }
    },
    async markRead(ids = []) {
      if (!ids || ids.length === 0) return
      await defHttp.post('/api/system/notifications/read', { ids })
      this.list = this.list.map((item) => {
        if (ids.includes(item.id)) {
          return { ...item, read: true }
        }
        return item
      })
    },
    async send(dto = {}) {
      await defHttp.post('/api/system/notifications/send', dto)
    },
    async getConfig(){
      const res = await defHttp.get('/api/notify/config',{})
      this.personalConfig = res.data.data
    },
    async updateConfig(body = {}){
      const res = await defHttp.post('/api/notify/updateConfig', body);
      if (res.data.code === 200) {
        this.personalConfig = body;
      } else {
        throw new Error(res.msg || '更新配置失败');
      }
    }
  },
})
